var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"4a62f8af37bbef0fb06b263b159c7e8fcbe6434f"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["squeeze-prd-vercel@squeeze-o2"]={id:"4a62f8af37bbef0fb06b263b159c7e8fcbe6434f"};
      